export type LabelMode = 'inside' | 'right' | 'hover'

type LabelModeParams = {
  isV2: boolean
  isBarVisible: boolean
  isSummary: boolean
  isDragging: boolean
  cellWidth: number
  rightSpacePercent: number
}

/**
 * ラベル配置モードを判定する。
 *
 * 末端タイプ（deliverable/task）: right → hover（バー外側に固定、左スペースへのフォールバックなし）
 * 親タイプ（workgroup/process/deliverableList）: 常に inside（名称はバー内固定、進捗率はGanttSlider側で別途表示）
 */
export const determineLabelMode = ({
  isV2,
  isBarVisible,
  isSummary,
  isDragging,
  cellWidth,
  rightSpacePercent,
}: LabelModeParams): LabelMode => {
  if (!isV2 || !isBarVisible) return 'inside'
  if (isDragging) return 'hover'
  if (cellWidth === 0) return 'hover'

  if (isSummary) return 'inside'

  const rightPx = (rightSpacePercent / 100) * cellWidth - 16
  if (rightPx > 0) return 'right'
  return 'hover'
}
